
import { Entity } from '../base/entity';

export class Currency extends Entity {
    
    public static readonly TABLENAME = 'currency';

    public static readonly ID = 'id';
    public static readonly CODE = 'code';
    public static readonly SIGN = 'sign';
    public static readonly NAME = 'name';
    public static readonly COUNTRY_ID = 'country_id';
    public static readonly EXCHANGE_RATE = 'exchange_rate'; 
    
    id: string;
    code: string;
    sign: string;
    name: string;
    countryId: number;
    exchangeRate: boolean;
}
